/*eslint-disable */
// import TprepSessionModel from '../../Model/TprepSession'
import request from '../../Utils/curl'
import Utility from "../../Utils/utility";

let TprepSessions =  {
  /**
   * tprep_sessionList
   */
  async tprep_sessionList (context, whereFilter=null) {
    try{
      Utility.showLoader = true;
      Utility.loadingMsg = "Please wait....";

      let post_data = new FormData();  
      if (whereFilter) {
        post_data.append('filter', JSON.stringify(whereFilter))
      }

      return await request.curl(context, "tprep_session_list", post_data)
        .then(async response => {
          return response
        });

    }
    catch(err){
      console.error('Exception occurred at tprep_sessionList() and Exception:',err.message)
    }
    finally{
      Utility.showLoader = false;
    }
  },

  /**
  * tprep_exam_name_list
  */
  async tprep_exam_name_list (context, whereFilter=null) {
    try {      
      let post_data = new FormData();
      if (whereFilter) {
        post_data.append('filter', JSON.stringify(whereFilter))
      }
      return await request.curl(context, "tprep_exam_name_list", post_data)
      .then(async response => {
        return response;
      });
    } 
    catch (err) {
      console.error("Exception occurred at tprep_exam_name_list() and Exception:",err.message)
    }
  },

  /**
   * tprep_sessionView
   */
  async tprep_sessionView (context, tprepSessionObj) {
    try {      
      let post_data = new FormData();

      if (typeof tprepSessionObj === "object" && tprepSessionObj !== null) {
        for (let key in tprepSessionObj) {
          if (tprepSessionObj[key] !== undefined && tprepSessionObj[key] !== null) {
            post_data.append(key, tprepSessionObj[key]);
          }
        }
      }
      else if (tprepSessionObj) {
        post_data.append('tps_id', tprepSessionObj);
      }

      return await request.curl(context, "tprep_session_view", post_data)
      .then(async response => {
        return response;
      });
    } 
    catch (err) {
      console.error("Exception occurred at tprep_sessionView() and Exception:",err.message)
    }    
  },

  /**
   * tprep_sessionAdd
   */
  async tprep_sessionAdd (context, tprep_sessionObj) {
    try{
      let post_data = new FormData();
    
      for (let key in tprep_sessionObj) {
        post_data.append(key, tprep_sessionObj[key]);
      }

      return await request.curl(context, "tprep_session_add", post_data)
      .then(async response => {
          return response;
      });
    }
    catch(err){
      console.error('Exception occurred at tprep_sessionAdd() and Exception:',err.message)
    }
  },

  /**
   * tprep_sessionEdit
   */
  async tprep_sessionEdit (context, tprep_sessionObj) {
    try{
      let post_data = new FormData();
    
      for (let key in tprep_sessionObj) {
        post_data.append(key, tprep_sessionObj[key]);
      }

      return await request.curl(context, "tprep_session_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at tprep_sessionEdit() and Exception:',err.message)
    }
  },

  /**
   * tprep_sessionSetTargetScore
   */
  async tprep_sessionSetTargetScore (context, tprep_sessionObj) {
    try{
      let post_data = new FormData();
    
      for (let key in tprep_sessionObj) {
        post_data.append(key, tprep_sessionObj[key]);
      }

      return await request.curl(context, "tprep_session_target_score_edit", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at tprep_sessionSetTargetScore() and Exception:',err.message)
    }
  },

  /**
   * tprep_sessionDelete
   */
  async tprep_sessionDelete (context, tprepSessionId) {
    try{
      let post_data = new FormData();
      
      post_data.append('tps_id', tprepSessionId);

      return await request.curl(context, "tprep_session_delete", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.log('Exception occurred at tprep_sessionDelete() and Exception:',err.message)
    }
  },
   /**
   * tprep_sessionCheckPayment
   */
  async tprep_sessionCheckPayment (context, checkPaymentObj) {
    try{
      let post_data = new FormData();
    
      for (let key in checkPaymentObj) {
        if (checkPaymentObj[key] && key == "user_subject_interest") {
          post_data.append(key, JSON.stringify(checkPaymentObj[key]));
        }
        else if (checkPaymentObj[key]) {
          post_data.append(key, checkPaymentObj[key]);
        }
      }

      return await request.curl(context, "tprep_session_check_payment", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.log('Exception occurred at tprep_sessionCheckPayment() and Exception:',err.message)
    }
  },

  /**
   * tprep_invite
   */
   async tprep_invite (context, tprep_sessionObj) {
    try{
      let post_data = new FormData();
    
      for (let key in tprep_sessionObj) {
        post_data.append(key, tprep_sessionObj[key]);
      }

      return await request.curl(context, "tprep_invite", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.log('Exception occurred at tprep_invite() and Exception:',err.message)
    }
  },

  /**
    * tprep_contract_update
    */
  async tprep_contract_update (context, tprep_contractObj) {
    try{
      let post_data = new FormData();

      let s3Attachments = []
      for (let key in tprep_contractObj) {
       if( key === 'tprep_contract' && tprep_contractObj.tprep_contract && tprep_contractObj.tprep_contract.length ){
          for (const attachment of tprep_contractObj.tprep_contract) {
            if (attachment.url && attachment.url.includes('amazonaws.com')) {
              // if file is already uploaded
              s3Attachments.push(attachment);
              continue
            }
            post_data.append(key, attachment);
         }
       }
       else {
         if (tprep_contractObj[key] || typeof tprep_contractObj[key] == "number") {
           post_data.append(key, tprep_contractObj[key]);
         }
       }
      }
      post_data.append('s3Attachments', JSON.stringify(s3Attachments))

      return await request.curl(context, "tprep_contract_update", post_data)
      .then(async response => {
        return response;
      });
    }
    catch(err){
      console.error('Exception occurred at tprep_contract_update() and Exception:',err.message)
    }
  }
}

export {
  TprepSessions
}
